import useSWR, { KeyedMutator } from "swr"

import { useGetUserData } from "../../../../hooks/useGetUserData"
import { getClientProtected } from "../../clients/clients"
import {
    TUsersOutput,
    userMapper,
} from "../../mappers/adminPortal/activeUsersMapper"
import { LIST_USERS_SYS_ADMIN, LIST_USERS_TO_MANAGE } from "../../urls/private"

export interface IActiveUsers {
    users: TUsersOutput | undefined
    isLoading: boolean
    isValidating: boolean
    isError: boolean
    mutate: KeyedMutator<TUsersOutput>
}

export const useActiveUsers = (
    approved: boolean,
    filterValue: string | null,
    searchParam: string
): IActiveUsers => {
    const { isEnaSysAdmin } = useGetUserData()
    const {
        data: users,
        error,
        isLoading,
        isValidating,
        mutate,
    } = useSWR(
        isEnaSysAdmin
            ? LIST_USERS_SYS_ADMIN(approved, filterValue)
            : LIST_USERS_TO_MANAGE(approved),
        async (url: string): Promise<TUsersOutput> => {
            try {
                const res = await getClientProtected(url)
                return userMapper.map(res)
            } catch {
                throw Error()
            }
        }
    )

    let searchedUser
    if (searchParam.length > 0) {
        searchedUser = users?.filter((user) =>
            user.fullName.toLowerCase().includes(searchParam.toLowerCase())
        )
    }

    return {
        users: searchedUser ?? users,
        isLoading,
        isValidating,
        isError: error,
        mutate,
    }
}

export default useActiveUsers
